import React from 'react'
import Postsmini from './postsmini'

export default function BlogSidebars() {
    return (
        <>
            <div className="card bg-white p-4 rounded shadow sticky-bar">
                <Postsmini />
            </div>
        </>
    )
}
